import React from "react";
import { withTranslation } from "react-i18next";
import { SEVERITY_COLORS } from "../constants/timelineSeverity";
import { getHeatmapIntensity, getMaxAnomalyCount } from "../utils/timelineChartUtils";
import AnomalyInfoTip from "../../AnomalyInfoTip";
import { formatAnomalyDisplayDate, formatAnomalyHeatmapPeriod } from "../../anomalyDateUtils";
import { formatTimelinePeriod } from "../utils/timelineFormatters";

const PeriodHeatmap = ({
  t,
  dataPoints,
  selectedPeriod,
  visibleRange,
  onPeriodSelect,
  onRangeSelect,
  rangeAnchorPeriod,
}) => {
  const maxCount = getMaxAnomalyCount(dataPoints);

  const isInRange = (period) => {
    if (!visibleRange) return false;
    return period >= visibleRange.from && period <= visibleRange.to;
  };

  const handleCellClick = (period, shiftKey) => {
    if (shiftKey && rangeAnchorPeriod) {
      onRangeSelect(period);
    } else {
      onPeriodSelect(period, shiftKey);
    }
  };

  return (
    <div className="anomaly-chart-card">
      <div className="chart-card-header">
        <h6 className="chart-header-with-tip">
          {t("MetricAnomalyTimeline.heatmap.label")}
          <AnomalyInfoTip text={t("MetricAnomalyTimeline.heatmapTip.label")} />
        </h6>
        <small className="chart-note-text">{t("MetricAnomalyTimeline.chartClickHint.label")}</small>
      </div>
      <div className="chart-card-body">
        <div className="mat-period-heatmap-scroll">
          <div className="mat-period-heatmap" role="grid" aria-label={t("MetricAnomalyTimeline.heatmap.label")}>
            {dataPoints.map((dp) => {
              const intensity = getHeatmapIntensity(dp.anomalyCount, maxCount);
              const sevColor = dp.hasAnomaly
                ? SEVERITY_COLORS[dp.maxSeverity] || "#94a3b8"
                : "#e2e8f0";
              const isSelected = selectedPeriod === dp.period;
              const inRange = isInRange(dp.period);
              const cellClass = [
                "mat-heatmap-cell",
                dp.hasAnomaly ? "mat-heatmap-cell--anomaly" : "mat-heatmap-cell--clean",
                isSelected ? "mat-heatmap-cell--selected" : "",
                inRange ? "mat-heatmap-cell--in-range" : "",
              ].filter(Boolean).join(" ");

              return (
                <button
                  key={dp.period}
                  type="button"
                  role="gridcell"
                  className={cellClass}
                  aria-label={t("MetricAnomalyTimeline.heatmapCell.label", {
                    period: formatTimelinePeriod(dp.period),
                    count: dp.anomalyCount || 0,
                  })}
                  aria-current={isSelected ? "true" : undefined}
                  onClick={(e) => handleCellClick(dp.period, e.shiftKey)}
                  style={{
                    "--hm-intensity": intensity,
                    "--hm-severity": sevColor,
                  }}
                >
                  <span
                    className="mat-heatmap-period"
                    title={formatAnomalyDisplayDate(dp.period)}
                  >
                    {formatAnomalyHeatmapPeriod(dp.period)}
                  </span>
                  {dp.hasAnomaly && (
                    <span className="mat-heatmap-dot" />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(PeriodHeatmap);
